import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
export function PageSection({ children, className, narrow, as: Tag = 'section', }) {
    return (_jsx(Tag, { className: cn('mx-auto w-full px-4 py-[var(--space-section)] md:px-8', narrow ? 'max-w-3xl' : 'max-w-6xl', className), children: children }));
}
